export default __webpack_public_path__ + "static/media/paymentLink.41920c19.svg";